import Link from '@/components/core/Link';
import TablePositionCell from '@/components/core/Table/CustomCells/TablePositionCell';
import { ModalsKey } from '@/enums/modalsKey';
import { PlayerPrivacyModeId } from '@/models/player/privacy-mode/id';
import { WalletService } from '@starsoft/common/services';
import { Decimal } from '@starsoft/common/services/Decimal';
import useTranslation from 'next-translate/useTranslation';
import { memo } from 'react';
import { GameDetailsContentCardProps } from './props';
import GameDetailsContentCardRow from './Row';
import GameDetailsContentCardSkeleton from './Skeleton';
import styles from './styles.module.scss';

function GameDetailsContentCard({
  bet,
  isLoading,
  position,
}: GameDetailsContentCardProps) {
  const { t } = useTranslation('common');
  const isPrivate: boolean =
    bet?.player?.privacyModeId?.toString() !=
    PlayerPrivacyModeId.Public?.toString();

  if (isLoading) {
    return <GameDetailsContentCardSkeleton />;
  }

  return (
    <div className={styles.card}>
      <div className={styles.card__header}>
        <TablePositionCell hideLabel position={position} />
        <Link
          modal={ModalsKey.UserProfile}
          href={`?player-slug=${bet?.player?.slug}`}
          className={`${styles.card__header__username} ${isPrivate ? styles['card__header__username--disabled'] : ''}`}
        >
          {isPrivate && <i className="fa-duotone fa-user-secret" />}
          {isPrivate ? t('private_label') : bet?.player?.username}
        </Link>
      </div>
      <div className={styles.card__content}>
        <GameDetailsContentCardRow
          title={t('payout_label')}
          value={WalletService.maskCurrency({
            amount: bet?.payout?.toNumber(),
            coin: bet?.coin,
          })}
          bet={bet}
          coin={bet?.coin}
          highlight
        />
        <GameDetailsContentCardRow
          title={t('wager_label')}
          value={WalletService.maskCurrency({
            amount: bet?.amount?.toNumber(),
            coin: bet?.coin,
          })}
          bet={bet}
          coin={bet?.coin}
        />
        <GameDetailsContentCardRow
          title={t('multiplier_label')}
          value={`${Decimal.fromSubunits(bet?.multiplier ?? '1', { scale: 4 }).toNumberString()}x`}
          hideCoin
        />
      </div>
    </div>
  );
}

export default memo(GameDetailsContentCard);
